import * as PropTypes from 'prop-types';
import video from './Video';

const oneOfConstant = constant =>
    constant && PropTypes.oneOf(Object.keys(constant).map(key => constant[key]));

const ImagePropShape = PropTypes.shape({
    src: PropTypes.string,
    altText: PropTypes.string
});

const VideoPropShape = {
    accentColor: PropTypes.string, // for html player
    autoplay: PropTypes.bool,
    className: PropTypes.string,
    contentId: PropTypes.string, // for youtube and twitch player
    hasControls: PropTypes.bool, // for youtube and html player
    hasFullScreen: PropTypes.bool,
    locale: PropTypes.string,
    loop: PropTypes.bool, // for youtube and html player
    muted: PropTypes.bool,
    sources: PropTypes.arrayOf(PropTypes.object), // for html player
    poster: PropTypes.string, // for html player and external
    rating: PropTypes.array,
    recipes: PropTypes.string,
    epicStillType: PropTypes.string,
    epicStillDurationSeconds: PropTypes.number,
    title: PropTypes.string,
    type: oneOfConstant(video.types),
    url: PropTypes.string
};

const SlidePropShape = {
    index: PropTypes.number.isRequired,
    item: PropTypes.shape({
        type: PropTypes.string.isRequired,
        onLoad: PropTypes.func,
        setRef: PropTypes.func,
        imgProps: ImagePropShape,
        vidProps: PropTypes.shape(VideoPropShape)
    }).isRequired
};

export default {
    oneOfConstant,
    SlidePropShape,
    ImagePropShape,
    VideoPropShape
};
